// Клиент для `/api/public/wellbores` — каталог стволов скважины публичного
// юзера (OSDU Wellbore, нижний уровень онтологии Field→Well→Wellbore).
// Тонкая обёртка над generic `crudClient` (см. crudClient.ts).
// Типы — единый источник правды: ts-rs-генерация из
// `crates/backend/web_api_types/src/wellbore.rs` (alias @webtypes, см.
// vite.config.ts / tsconfig.app.json). Регенерация — `cargo test -p web_api_types`.

import type { WellboreDto } from '@webtypes/WellboreDto'
import type { CreateWellboreBody } from '@webtypes/CreateWellboreBody'
import type { UpdateWellboreBody } from '@webtypes/UpdateWellboreBody'
import { crudClient, ensureOk } from './crudClient'

export type { WellboreDto, CreateWellboreBody, UpdateWellboreBody }
// 409 = ствол используется (FK ON DELETE RESTRICT — когда на wellbore начнут
// ссылаться) ЛИБО это дефолтный ствол скважины (его нельзя ни удалить, ни
// перенести под другую скважину); страница ловит его `instanceof InUseError`.
export { InUseError } from './crudClient'

const client = crudClient<WellboreDto, CreateWellboreBody, UpdateWellboreBody>(
  '/api/public/wellbores',
  'Ствол используется — удалить нельзя',
)

export const listWellbores = client.list
export const createWellbore = client.create
export const updateWellbore = client.update
export const deleteWellbore = client.remove

// Сделать ствол ОСНОВНЫМ. Отдельный ресурс, а не поле PATCH: на сервере это
// транзакция на две строки (снять дефолт со старого, поднять новому), и в
// COALESCE-семантику частичного апдейта она не ложится.
//
// ⚠ Пересаживается РОЛЬ, а не данные: композиты, файлы и журнал прежнего
// основного остаются на нём. Меняется то, куда попадёт всё, что адресовано
// СКВАЖИНОЙ без явного ствола — включая старые проекты, знающие только скважину.
//
// Идемпотентно: повтор на уже основном стволе — тоже успех.
export async function setDefaultWellbore(id: number): Promise<void> {
  const resp = await fetch(`/api/public/wellbores/${id}/default`, {
    method:      'POST',
    credentials: 'same-origin',
  })
  await ensureOk(resp)
}
